(function() {
    const InvioCredenzialiService = function($http, CONSTANTS) {
        this.datiMito = null;
        this.canaliInvioCredenziali = {
            codice: '',
            password: ''
        };

        this.reset = () => {
            this.datiMito = null;
            this.canaliInvioCredenziali = {
                codice: '',
                password: ''
            };
        };

        this.getDatiCliente = (ndg) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.RECUPERA + '/' + ndg
            });
        };

        this.getDatiMito = (codiceMito) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + codiceMito
            });
        };

        this.recuperaConfigurazioni = () => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOMINI.CONFIGURAZIONI + "VARIAZIONE"
            });
        };
    };

    InvioCredenzialiService.$inject = [ '$http', 'Mitom_CONSTANTS' ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomInvioCredenzialiService', InvioCredenzialiService);
})();